<template>
    <div style="position:relative; top:150px;">
        <content-header
            icona="fas fa-check"
            :titolo="'Benvenuto ' + ragSoc">
        </content-header>

    
        <div class="card sn-card-contenuto " >
            <div class="card-body">
                <div class="row">


                    <!-- MAIN -->
                    <div class="col-md-9">
                        
                        <!-- CORSI CALENDARIZZATI -->
                        <!--
                        <div class="card" >
                            <div class="card-header">
                                    <i class="fas fa-graduation-cap text-bucher"></i>&nbsp;Corsi calendarizzati 
                            </div>
                            <div class="card-body">
                                <table class="table table-sm table-custom">
                                    <thead>
                                        <tr>
                                            <th>Cod.</th>
                                            <th>Descrizione</th>
                                            <th># Posti</th>
                                            <th><i class="fas fa-bars fa-fw"></i></th>
                                        </tr>
                                    </thead>
                                    <tbody></tbody>
                                </table>
                            </div>
                        </div>-->


                        <!-- CATALOGO CORSI -->
                        <div class="card mt-4" >
                            <div class="card-header">
                                    <i class="fas fa-shopping-cart text-bucher"></i>&nbsp;Corsi disponibili
                            </div>
                            <div class="card-body">

                                <div class="d-flex">
                                    
                                    <div class="card me-2" style="width:350px;" v-for="o, i in dtCorsiCatalogo" :key="i">
                                        <div class="card-header" style="font-weight: bold; min-height: 100px;">
                                            {{o.cct_titolo}}
                                        </div>  
                                        <div class="card-body">
                                            <p>{{o.cct_descrizione}}</p>
                                            <p><strong>Posti</strong>: {{o.cct_npartecipanti_max}} </p>
                                            <p><strong>Tipo</strong>: 
                                                <i class='fas fa-certificate fa-sm fa-fw text-warning' v-if="o.cct_idTipo==1"></i>
                                                <i class='fas fa-handshake fa-sm fa-fw text-info' v-else></i>
                                                &nbsp;{{o.cot_descrizione}}</p>
                                            <button type="button" class="btn btn-outline-success" @click="StartPrenotaCorso(o)">Prenota</button>
                                        </div>  
                                    </div>

                                </div>
                                
                                
                            </div>
                        </div>

                    </div>

                    <!-- COLONNA DX -->
                    <div class="col-md-3">
                        <div class="card" >
                            <div class="card-header">
                                <i class="fas fa-industry text-bucher"></i>&nbsp;Dati aziendali 
                            </div>
                            <div class="card-body">
                                    Si prega di completare e mantenere aggiornati i dati aziendali. <br /><br />
                                    <router-link to="/dati-aziendali" class="btn btn-primary">
                                        <i class="fas fa-share-square fa-fw"></i>&nbsp;Modifica Dati Aziendali
                                    </router-link>
                            </div>
                        </div>

                        <div class="card" >
                            <div class="card-header">
                                <i class="fas fa-users text-bucher"></i>&nbsp;Personale
                            </div>
                            <div class="card-body">
                                    Mantenete aggiornato il vostro archivio del personale. <br /><br />
                                    <router-link to="/personale" class="btn btn-primary">
                                        <i class="fas fa-share-square fa-fw"></i>&nbsp;Archivio personale
                                    </router-link>
                            </div>
                        </div>
                    </div>

                    
                    
                


                </div>


            </div>
        </div>

    </div>
  
    

    <!-- *** DIALOG PRENOTA *** -->
    <dialog class="dialogGiletta">
        <div class="d-flex mb-3" style="border-bottom:solid 1px #ccc" >
            <div class="">
                <i class="fas fa-shopping-cart text-primary"></i>
            </div>
            <div class="ms-2">
                <h5>Prenotazione corso</h5>
            </div>
        </div>

        <div class="mb-2 mt-2">
            <strong>{{ oPrenota.titolo }}</strong>
        </div>

        <div class="row mb-3">
            <div class="col-md-6 mb-3">
                <label>Numero partecipanti</label>
                <input type="number" class="form-control" v-model="oPrenota.nPartecipanti">
            </div> 
        </div>

        <div class="row mb-3">
            <div class="col-md">
                <label>Note/comunicazioni</label>
                <textarea class="form-control" maxlength="150" v-model="oPrenota.note" ></textarea>
            </div> 
        </div>


        <div class="d-flex justify-content-end">
            <button type="button" class="btn btn-outline-dark me-2" @click="ChiudiPrenota">Annulla</button>
            <button type="button" class="btn btn-outline-primary" @click="PrenotaCorso"><i class="fas fa-chevron-right"></i>&nbsp;Prenota</button>
        </div>


    </dialog>
    
</template>

<script>
import ContentHeader from '@/components/layout/ContentHeader.vue';

export default {
    name: 'DashboardView',
    components: {
        ContentHeader
    },
    inject: ['cfg'],
    data: function() {
        return {
            dtCorsiCatalogo: [],

            ragSoc: "",

            oPrenota: {
                idCct: -1,
                idAna: -1,
                nPartecipanti: 0,
                note: "",
                titolo: "",
                token: "",
            },
        }
    },
    methods: {
        GetListCorsiCatalogo() {
            //Carica lista elementi
            fetch(this.cfg.apisrv + "/api/CorsiCatalogo/GetListCorsiCatalogo?token=" + this.$store.state.UserInfo.token)
                .then(response => response.json())
                .then(obj => {
                    this.dtCorsiCatalogo = obj;
                });
        },


        // *** PRENOTAZIONE CORSO
        StartPrenotaCorso(o) {
            this.oPrenota.idCct = o.cct_id;
            this.oPrenota.idAna = this.$store.state.UserInfo.id;
            this.oPrenota.titolo = o.cct_titolo;
            const dialog = document.querySelector(".dialogGiletta");
            dialog.showModal();
        },
        ChiudiPrenota() {
            const dialog = document.querySelector(".dialogGiletta");
            dialog.close();
        },
        PrenotaCorso() {
            let oSubmit = [];
            oSubmit = this.oPrenota;
            oSubmit.token = this.$store.state.UserInfo.token;
                  
            //this.ClearMessaggio();
            this.$store.commit('Messaggio', {parms: [true, ['Prenotazione in corso...'], 'alert alert-info', 'fa-spinner', true, 0]});
            fetch(this.cfg.apisrv + "/api/CorsiPrenotazioni/PrenotaCorso", {
                "method": "POST",
                "headers": {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                "body": JSON.stringify(oSubmit)
            }).then(response => response.json())
                .then(obj => {
                    if (obj.status == "OK") {
                        this.$store.commit('Messaggio', {parms: [true, ['Salvataggio effettuato.'], 'alert alert-success', 'fa-check', false, 2000]});
                        this.$router.push("/corsi");  
                    }
                    else {
                        this.$store.commit('Messaggio', {parms: [true, obj.dati, 'alert alert-warning', 'fa-times', false, 3000]});
                     

                        // this.mostraMessaggio = true;
                        // this.alertMessaggio = obj.dati;
                        // this.alertClass = "alert alert-warning";
                        // this.alertIcon = "fa-xmark"
                        // this.alertIconSpin = false
                    }
            });

        },
    },
    mounted: function() {
        if(this.$store.state.UserInfo.token == '') this.$router.push("/");

        this.ragSoc = this.$store.state.UserInfo.ragSoc;
        this.GetListCorsiCatalogo();
    }
}
</script>